export const displayOrReactivateSmartbox = (data={smartbox: null, tilte:"", content:"", preloaderClass:null})=>{

    const {smartbox, tilte, content, preloaderClass} = data;

    if (smartbox.hasBeenRendered && smartbox.currentState !== "close") {
        return smartbox.reactivate();
    };

    smartbox.title = "txt485";
    smartbox.content = preloaderClass.render();

    smartbox.title = tilte;
    smartbox.content += content;
    smartbox.onClose = () => { smartbox = null; };
    smartbox.render();
    smartbox.sidelize();
    preloaderClass.show();
    // return smartbox.render();    

    // return
};
